import { ManufacturerSearchResultOfListingMatch } from '@deltek/specification-client/core/Models/listingSearch'
import { ListingLevel } from '@deltek/specification-client/core/Models/product'

export const ProductSearchResolver = {
    result: (): ManufacturerSearchResultOfListingMatch => ({
        facets: [
            {
                name: 'Categories',
                values: [
                    {
                        value: 'Doors',
                    },
                    {
                        value: 'Windows',
                    },
                ],
            },
            {
                name: 'ListingLevels',
                values: [
                    {
                        value: 'Basic',
                    },
                    {
                        value: 'Enhanced',
                    },
                ],
            },
            {
                name: 'Partnerships',
                values: [
                    {
                        value: 'BIM',
                    },
                    {
                        value: 'Sustainability',
                    },
                ],
            },
        ],
        matches: [
            {
                listingId: '1',
                categories: ['Windows'],
                displayNameWithFirmName: '`a`%|%`b`',
                firmDisplayName: 'AA',
                firmId: 'f1',
                firmLogoUrl: '',
                firmName: 'Pella Corporation',
                type: ListingLevel.Manufacturer,
                images: [
                    {
                        filename: '',
                    },
                ],
                isActive: true,
                lastUpdated: '',
                productId: '1',
                productName: 'Wood Bay and Bow Windows',
                productType: 'Wood Windows',
                sectionName: 'WOOD WINDOWS',
                submissionStatus: '',
                videos: [
                    {
                        videoStillImageUrl: '',
                    },
                ],
                specAgentProductTypeId: 10,
            },
            {
                categories: ['Doors'],
                listingId: '2',
                displayNameWithFirmName: '`a`%|%`b`',
                firmId: 'f2',
                firmName:
                    'Besam Entrance Solutions; an ASSA ABLOY Group Company',
                productId: '2',
                productName: 'RD100',
                productType: 'Manual Revolving Door Entrances',
                firmLogoUrl: '',
                type: ListingLevel.Manufacturer,
                submissionStatus: '',
                lastUpdated: '',
                isActive: true,
                sectionName: 'REVOLVING DOORS',
                videos: [
                    {
                        videoStillImageUrl: '',
                    },
                ],
                images: [
                    {
                        filename: '',
                    },
                ],
                specAgentProductTypeId: 20,
            },
            {
                categories: ['Doors'],
                listingId: '3',
                displayNameWithFirmName: '`a`%|%`b`',
                firmId: 'f3',
                firmName:
                    'Besam Entrance Solutions; an ASSA ABLOY Group Company',
                productId: '3',
                productName: '3-wing RD3L',
                productType: 'Automatic Revolving Door Entrances',
                firmLogoUrl: '',
                type: ListingLevel.Manufacturer,
                submissionStatus: '',
                lastUpdated: '',
                isActive: true,
                sectionName: 'REVOLVING DOORS II',
                videos: [
                    {
                        videoStillImageUrl: '',
                    },
                ],
                images: [
                    {
                        filename: '',
                    },
                ],
                specAgentProductTypeId: 30,
            },
        ],
        count: 3,
    }),
}

export const ProductSearchAutosuggestResolver = {
    result: (): { result: string[] } => ({
        result: ['Walls', 'Windows'],
    }),
}
